import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useUserStore from '../store/userStore';
import useUserFeaturesStore from '../store/userFeaturesStore';

/**
 * Provider component để tự động fetch features khi user đăng nhập
 * Đặt component này ở root của app (trong App.jsx hoặc Layout)
 */
const FeatureProvider = ({ children }) => {
  const user = useUserStore((state) => state.user);
  const userIdRef = useRef(null); // Track user ID để phát hiện thay đổi user

  const { fetchUserFeatures, clearCache } = useUserFeaturesStore();

  useEffect(() => {
    const currentUserId = user?.id;

    // Nếu user thay đổi (bao gồm logout → login khác)
    if (userIdRef.current !== null && currentUserId !== userIdRef.current) {
      // Clear cache hoàn toàn trước khi fetch user mới
      clearCache();
    }

    // Update user ID ref
    userIdRef.current = currentUserId;

    if (user) {
      // User đã đăng nhập -> fetch features (force = true để đảm bảo fetch lại)
      fetchUserFeatures(true);
    }
  }, [user, fetchUserFeatures, clearCache]);

  return children;
};

FeatureProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FeatureProvider;

